import React, { useState, useEffect } from "react";
import "./HeroSection.css";
import banner_1 from "../../../assets/banner/Iug_banner_1.webp";
import banner_2 from "../../../assets/banner/banner-2.jpg";
import banner_7 from "../../../assets/banner/banner-7.jpg";
import banner_4 from "../../../assets/banner/banner-4.jpg";
import banner_5 from "../../../assets/banner/banner-5.jpg";
import banner_6 from "../../../assets/banner/banner-6.jpg";
import banner_3 from "../../../assets/banner/banner-3.jpg";
import banner_8 from "../../../assets/banner/banner-8.jpg";
import banner_9 from "../../../assets/banner/express-website-baner.png";

const HeroSection = () => {
  const slides = [
    { id: 2, image: banner_8 },
    { id: 1, image: banner_1 },
    { id: 4, image: banner_4 },
    { id: 8, image: banner_5 },
    { id: 9, image: banner_2 },
    { id: 3, image: banner_3 },
    { id: 5, image: banner_6 },
    { id: 6, image: banner_7 },
    { id: 7, image: banner_9 },
  ].sort((a, b) => a.id - b.id);

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => setCurrentIndex(index);

  return (
    <section className="hero-section">
      <div
        className="slides-container"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((slide) => (
          <div
            className="slide"
            key={slide.id}
            style={{
              backgroundImage: `url(${slide.image})`,
            }}
          ></div>
        ))}
      </div>

      {/* Pagination Dots */}
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        className="prev"
        onClick={() =>
          setCurrentIndex((currentIndex - 1 + slides.length) % slides.length)
        }
      >
        &#10094;
      </button>
      <button
        className="next"
        onClick={() => setCurrentIndex((currentIndex + 1) % slides.length)}
      >
        &#10095;
      </button>
    </section>
  );
};

export default HeroSection;
